export const localeFilter = {
  title: { ru: "titleRu", en: "titleEn" }
}
